import moment from "moment";

function isWeekend(m) {
  const day = m.day();
  return day === 0 || day === 6;
}

function isPublicHoliday(m, holidayDates) {
  if (!holidayDates || !holidayDates.size) return false;
  return holidayDates.has(m.format("YYYY-MM-DD"));
}

function isNonWorkingDay(m, holidayDates) {
  return isWeekend(m) || isPublicHoliday(m, holidayDates);
}

/** First Mon–Fri (non-holiday) strictly after the given calendar day. */
export function getNextWorkingDay(dateValue, holidayDates) {
  let m = moment(dateValue).startOf("day");
  if (!m.isValid()) return null;
  m = m.add(1, "day");
  while (isNonWorkingDay(m, holidayDates)) {
    m = m.add(1, "day");
  }
  return m;
}

/**
 * Unfilled workdays stay "pending" until the next working day (Fri → Mon across the weekend).
 */
export function isDailyWorkUpdatePending(
  workDate,
  referenceDate = moment(),
  holidayDates
) {
  const workDay = moment(workDate).startOf("day");
  const ref = moment(referenceDate).startOf("day");
  if (!workDay.isValid() || !ref.isValid() || isNonWorkingDay(workDay, holidayDates)) {
    return false;
  }

  const graceDeadline = getNextWorkingDay(workDay, holidayDates);
  if (!graceDeadline) return false;

  return ref.isSameOrBefore(graceDeadline, "day") && ref.isAfter(workDay, "day");
}

/** Whether a daily work update for workDate may be submitted on referenceDate (current month). */
export function canSubmitDailyWorkForDate(
  workDate,
  referenceDate = moment(),
  holidayDates
) {
  const workDay = moment(workDate).startOf("day");
  const ref = moment(referenceDate).startOf("day");
  if (!workDay.isValid() || !ref.isValid()) return false;
  if (isNonWorkingDay(workDay, holidayDates)) return false;
  if (ref.isSame(workDay, "day")) return true;
  return isDailyWorkUpdatePending(workDate, referenceDate, holidayDates);
}
